import { Nav, Navbar } from 'react-bootstrap';
import { RouteItems, routes } from 'sitemap';
import { capitalize } from 'helpers/utils';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import { ArrowLeftToLine, ArrowRightFromLine } from 'lucide-react';
import { useAppContext } from 'providers/AppProvider';
import classNames from 'classnames';
import Button from 'components/base/Button';
import NavbarTopNav from '../navbar-horizontal/NavbarTopNav';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import NavbarVerticalCollapseProvider from './NavbarVerticalCollapseProvider';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'providers/AuthProvider'


const NavbarVerical = () => {
  const {
    config: {
      navbarPosition,
      openNavbarVertical,
      navbarVerticalAppearance,
      isNavbarVerticalCollapsed
    },
    setConfig
  } = useAppContext();

  const { breakpoints } = useBreakpoints();
  const { t } = useTranslation();
  const auth = useAuth();


  //console.log(routes);
  // Define the output array to store accessible routes' names
  const accessibleRoutes: RouteItems[] = [];
  // Loop over each route, apply auth check, and add if accessible
  routes.forEach(route => {
    if (route.label === '') {
      accessibleRoutes.push(route);
    } else
      if (auth.checkFeatureAccess(route.label, 'sidebar')) {
        accessibleRoutes.push(route);
      }
  });

  return (
    <NavbarVerticalCollapseProvider>
      <Navbar
        className={classNames('navbar-vertical', {
          'navbar-darker': navbarVerticalAppearance === 'darker'
        })}
        expand="lg"
        variant=""
      >
        <Navbar.Collapse id="navbarVerticalCollapse" in={openNavbarVertical}>
          <div className="navbar-vertical-content">
            <Nav className="flex-column" as="ul" id="navbarVerticalNav">

              {/* Render first level pages */}
              {accessibleRoutes.map((route, index) => (
                <Nav.Item key={route.label + "-" + index}>
                  {!route.labelDisabled && (
                    <>
                      <p className="navbar-vertical-label">
                        {capitalize(t(route.label))}
                      </p>
                      <hr className="navbar-vertical-line" />
                    </>
                  )}
                  {/* Render second level pages */}
                  <NavbarVerticalMenu level={1} routes={route.pages} />
                </Nav.Item>
              ))}
            </Nav>

            {navbarPosition === 'combo' && breakpoints.down('lg') && (
              <div className="move-container">
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr" />
                </div>
                <NavbarTopNav />
              </div>
            )}
          </div>
        </Navbar.Collapse>
        <div className="navbar-vertical-footer">
          <Button
            className="navbar-vertical-toggle border-0 fw-semi-bold w-100 white-space-nowrap d-flex align-items-center"
            onClick={() => {
              setConfig({
                isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed
              });
            }}
          >
            {isNavbarVerticalCollapsed ? (
              <ArrowRightFromLine size={16} className="mb-1" />
            ) : (
              <>
                <ArrowLeftToLine size={16} className="mb-1" />
                <span className="ms-2">Collapsed View</span>
              </>
            )}
          </Button>
        </div>
      </Navbar>
    </NavbarVerticalCollapseProvider>
  );
};

export default NavbarVerical;
